import React, { memo, useCallback, useMemo } from "react";
import Combobox from "@ls/react-combobox-grid";
import {
  selectFetchingGroups,
  selectUncommittedAllGroupEntities,
  selectUncommittedGroupTypeEntity,
  selectUncommittedGroupValues,
} from "state/selections/selector";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "state/selections/actions";
import styled from "styled-components";
const TextInputOverflow = styled.div`
  & div {
    & div {
      & div {
        height: auto !important;
        overflow: none !important;
        & div {
          max-width: none !important;
          flex-wrap: wrap !important;
        }
      }
    }
  }
`;


const GroupSelector = () => {
  const dispatch = useDispatch();
  const values = useSelector(selectUncommittedGroupValues);
  const loading = useSelector(selectFetchingGroups);

  const groupTypeGroups = useSelector(selectUncommittedAllGroupEntities);
  const groupTypeEntity = useSelector(selectUncommittedGroupTypeEntity);

  const options = useMemo(
    () => [...groupTypeGroups].sort(groupTypeEntity?.groupTypeGroupSorter),
    [groupTypeGroups, groupTypeEntity]
  );
  const onChange = useCallback(
    (groups) => {
      dispatch(actions.setGroup(groups));
    },
    [dispatch]
  );

  let isCustomGroup = groupTypeEntity?.value === "CUSTOM";
  // Doug Request - Change "Custom" Group Types label from `{description}` to `{description} ({id})`.
  // Combobox module only points to one attribute with labelKey.
  // Combobox module had access to id, but did not have knowledge of Group Type.

  return (
    <TextInputOverflow>
      <Combobox
        placeholder="Groups..."
        options={options}
        onChange={onChange}
        value={values}
        label="Groups: "
        loading={loading}
        valueKey={groupTypeEntity?.comboboxValueKey}
        labelKey={groupTypeEntity?.comboboxLabelKey}
        columnDefs={groupTypeEntity?.groupPickerColumnDefs}
        isCustomGroup={isCustomGroup}
        variation={1}
        multi
      />
    </TextInputOverflow>
  );
};

export default memo(GroupSelector);
